import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from "rxjs";
import * as d3Scale from "d3-scale";
import * as d3Shape from "d3-shape";
import * as d3Array from "d3-array";
import * as d3Axis from "d3-axis";
import * as d3 from "d3";
import { DynaDimmerStateService } from "../../../core-module/services/state/dyna-dimmer-state.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
import {
  updateScenes10 as _updateScenes10,
  updateScenes9 as _updateScenes9,
  updateScenes8 as _updateScenes8,
  updateScenes7 as _updateScenes7,
  updateScenes6 as _updateScenes6,
  updateScenes5 as _updateScenes5,
  updateScenes4 as _updateScenes4,
  updateScenes3 as _updateScenes3,
  updateScenes2 as _updateScenes2,
} from "../../graph-utils/dyna-scene-updates";
import {
  addTMAXShutDown as _addTMAXShutDown,
  addTMAXStart as _addTMAXStart,
  addTMAXEnd as _addTMAXEnd,
} from "../../graph-utils/dyna-tmax-markers";
import {
  drawDynaLineAndPath as _drawDynaLineAndPath,
  addDynaDrag as _addDynaDrag,
  dragEndedDyna as _dragEndedDyna,
  buildDynaDataPoints,
} from "../../graph-utils/dyna-graph-common";
@Component({
  standalone: false,
  selector: "app-samplegraphdynanontime",
  templateUrl: "./samplegraphdynanontime.component.html",
  styleUrls: ["./samplegraphdynanontime.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SamplegraphdynanontimeComponent implements OnInit, OnDestroy {
  @Input() readOnly: boolean = true;

  private readonly destroy$ = new Subject<void>();

  inputXRange = [0, 24];

  inputYRange = [0, 100];

  data1: LegacyAny[] = [
    { dyanXTime: 0, dyanYOutput: 40 },
    { dyanXTime: 15, dyanYOutput: 40 },
    { dyanXTime: 15, dyanYOutput: 100 },
    { dyanXTime: 16, dyanYOutput: 100 },
    { dyanXTime: 16, dyanYOutput: 10 },
    { dyanXTime: 17, dyanYOutput: 10 },
    { dyanXTime: 17, dyanYOutput: 80 },
    { dyanXTime: 18, dyanYOutput: 80 },
    { dyanXTime: 18, dyanYOutput: 30 },
    { dyanXTime: 24, dyanYOutput: 30 },
    { dyanXTime: 24, dyanYOutput: 40 },
    { dyanXTime: 24, dyanYOutput: 40 },
    // {dyanXTime:"00", dyanYOutput:10},
    // {dyanXTime:"03", dyanYOutput:10},
    // {dyanXTime:"03", dyanYOutput:80},
    // {dyanXTime:"20", dyanYOutput:80},
    // {dyanXTime:"20", dyanYOutput:10},
    // {dyanXTime:"24", dyanYOutput:10}
  ];
  data: LegacyAny[] = [];
  dataFromTableValues: LegacyAny[] = [];

  savedPrevData: LegacyAny[] = [];

  focus;
  drag;
  public margin = { top: 50, right: 50, bottom: 50, left: 50 };
  public width: number;
  public height: number;
  public x: LegacyAny;
  public y: LegacyAny;
  public svg4: LegacyAny;
  public line: d3.Line<[number, number]>; // this is line defination
  public area: d3.area<[number, number]>; // this is area defination
  public id = "lineChart";
  public color2 = "#00b36b";
  newData: LegacyAny;
  changedPoint: LegacyAny;
  feedMaxValue: LegacyAny = 112;
  NormalLevelMaximum: LegacyAny;
  BackgroundLevelMaximum: LegacyAny;
  Maxdata: LegacyAny = [];
  Tmaxstart: LegacyAny;
  TmaxEnd: LegacyAny;
  TmaxShutDown: LegacyAny;
  scrolPoint: LegacyAny;
  deRatingdyanYOutput: LegacyAny;
  LamOffValue: LegacyAny;
  DtlDimStopValue: LegacyAny;
  TmaxdeRatingDim: LegacyAny;
  Forbidenarea: d3.area<[number, number]>; // this is area defination
  deratingLabelYaxis: number;
  TminEnd: LegacyAny;
  MaxLimit: LegacyAny;
  TmindeRatingDim: LegacyAny;

  constructor(
    private dynaDimmer: DynaDimmerStateService,
    private graphState: GraphStateService
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.dynaDimmer.getDynaMidPointShiftValue
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
      this.addDeratingLine();
    });
    // this.dynaDimmer.getDynaTimeReferencedMode.subscribe(response => {

    //   if(response===false)
    //   {
    //     this.dynaDimmer.getFinalDynaDimmerData.subscribe(response=>{
    //       this.addDynaDetails(response);

    //     });
    //   }
    // })
    this.dynaDimmer.getFinalDynaDimmerData
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
      if (response) {
        this.addDynaDetails(response);
      }
    });

    this.newData = this.data;

    this.buildSvg();
    this.addXandYAxis();
    this.drawLineAndPath();
    this.addDrag();
    this.addDeratingLine();
  }
  addDynaDetails(response: LegacyAny) {
    if (response != null && response.length > 0) {
      const newData1 = JSON.parse(response);
      this.data = [];
      this.dataFromTableValues = [];
      this.dataFromTableValues = buildDynaDataPoints(newData1, (t) => {
        if (t >= 12 && t <= 24) {
          return t - 12;
        }
        if (t >= 0 && t <= 11.59) {
          return t + 12;
        }
        return 0;
      });
      this.data = this.dataFromTableValues;
      this.savedPrevData = this.data;
      this.buildSvg();
      this.addXandYAxis();
      this.drawLineAndPath();
      this.addDrag();
      this.addDeratingLine();
    }
  }
  public buildSvg() {
    this.svg4 = d3.select("#svg3");
    this.width = 600 - this.margin.left - this.margin.right;
    this.height = 550 - this.margin.top - this.margin.bottom;
  }
  public addXandYAxis() {
    // range of data configuring
    this.x = d3.scaleLinear().range([0, this.width]);
    this.y = d3.scaleLinear().range([this.height, 0]);
    this.x.domain(this.inputXRange);
    this.y.domain(this.inputYRange);
  }

  public drawLineAndPath() {
    // Delegated to shared dyna-graph-common.drawDynaLineAndPath.
    // samplegraphdynanontime-specific: no Y clamping, gradient4,
    // x-label at x(12), custom x-grid tick format rotated 12h..11h.
    _drawDynaLineAndPath.call(this, {
      hostSvg: this.svg4,
      gradientId: "gradient4",
      xLabelAnchor: 12,
      clampY: false,
      xGridExtraFormat: (_d, i) =>
        [
          12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 1, 2, 3, 4, 5, 6, 7, 8,
          9, 10, 11,
        ][i],
    });
  }

  // gridlines in x axis function
  make_x_gridlines() {
    return d3.axisBottom(this.x).tickPadding(10).ticks(24);
    //.tickFormat((d,i)=>[0,1, 2, 3, 4, 5, 6,7 ,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24][i]);

    //tickFormat(x=>`(${x.toFixed(1)})`);
  }
  // gridlines in y axis function
  make_y_gridlines() {
    return d3.axisLeft(this.y).ticks(10);
  }

  public addDrag() {
    _addDynaDrag.call(this);
  }

  dragstarted() {
    return this;
  }

  public dragended(d) {
    _dragEndedDyna.call(this, d);
  }

///SCENE 10


  ///SCENE 10 - delegated to shared dyna-scene-updates helpers
  updateScenes10(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes10.call(this, data, draggedData);
  }
  updateScenes9(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes9.call(this, data, draggedData);
  }
  updateScenes8(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes8.call(this, data, draggedData);
  }
  updateScenes7(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes7.call(this, data, draggedData);
  }
  updateScenes6(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes6.call(this, data, draggedData);
  }
  updateScenes5(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes5.call(this, data, draggedData);
  }
  updateScenes4(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes4.call(this, data, draggedData);
  }
  updateScenes3(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes3.call(this, data, draggedData);
  }
  updateScenes2(data: LegacyAny[], draggedData: LegacyAny) {
    _updateScenes2.call(this, data, draggedData);
  }

  getDynaTimeXRefernce(dynaModX: number) {
    if (dynaModX >= 0 && dynaModX <= 12) {
      dynaModX = dynaModX + 12;
    } else if (dynaModX >= 12 && dynaModX <= 24) {
      dynaModX = dynaModX - 12;
    }
    const hh = dynaModX.toString().split(".")[0];
    let mm = "00";

    try {
      mm = dynaModX.toString().split(".")[1].substring(0, 2);
      if (mm.length === 1) {
        mm = mm.concat("0");
      }
    } catch (error) {}
    if (Number(mm) > 59) mm = "59";
    return hh + ":" + mm;
  }

  addDeratingLine() {
    let midNightShiftPoint = 0;
    let x1Value = 12;

    this.dynaDimmer.getDynaMidPointShiftValue.subscribe((response) => {
      midNightShiftPoint = Number(response) || 0;
    });
    if (midNightShiftPoint > 0) {
      midNightShiftPoint = midNightShiftPoint / 100;
      x1Value = x1Value + midNightShiftPoint * 1.6;
    } else if (midNightShiftPoint < 0) {
      midNightShiftPoint = midNightShiftPoint / 100;
      x1Value = x1Value + midNightShiftPoint * 1.6;
    } else {
      midNightShiftPoint = midNightShiftPoint / 100;
      x1Value = x1Value + midNightShiftPoint;
    }
    if (this.focus != null) {
      this.focus
        .append("line")
        .style("stroke", "blue")
        .style("stroke-dasharray", "5, 5")
        .text("Mid Night Shift")
        .attr("x1", this.x(x1Value))
        .attr("y1", this.y(100))
        .attr("x2", this.x(x1Value))
        .attr("y2", this.y(0));
    }

    // .attr("x1", this.x(9)).attr("y1", this.y(100))
    // .attr("x2", this.x(9)).attr("y2", this.y(0));
    if (this.focus != null) {
      this.focus
        .append("text")
        .attr("x", this.x(9))
        .attr("y", this.y(100))
        // .attr("transform", "rotate(-90," + this.x(-this.deratingLabelYaxis) + "," + this.y(this.deRatingdyanYOutput) + ")")
        .attr("text-anchor", "start")
        .style("font", "10px Signify-Relative-Bold")
        .style("color", "lightgrey")
        .style("text-anchor", "middle")
        .text("");
    }
  }

  addTMAXShutDown() {
    _addTMAXShutDown.call(this);
  }

  addTMAXStart() {
    _addTMAXStart.call(this);
  }

  addTMAXEnd() {
    _addTMAXEnd.call(this);
  }
}

